import { WSAlert } from "@wingspanhq/fe-component-library";
import { RequirementsUrlQuery } from "../../../BulkReview/hooks/useBulkReviewRequirements";
import { useGoToBulkReviewRequirements } from "../../../BulkReview/paths";
import {
  PayeeFilterEligibilityStatus,
  PayeeFilterRequirementStatus,
  PayeeFilters
} from "./filters/types";

type Props = {
  payeeFilters: PayeeFilters;
};

function mapPayeeFiltersToRequirement(
  payeeFilters: PayeeFilters
): RequirementsUrlQuery {
  return {
    filter: {
      requirementDefinitionId: payeeFilters.requirementDefinitionId,
      status:
        payeeFilters.eligibilityStatus === PayeeFilterEligibilityStatus.Eligible
          ? PayeeFilterRequirementStatus.Complete
          : payeeFilters.eligibilityStatus ===
            PayeeFilterEligibilityStatus.NotEligible
          ? PayeeFilterRequirementStatus.Incomplete
          : payeeFilters.requirementStatus
    }
  };
}

export const AlertBulkReview: React.FC<Props> = props => {
  const goToBulkReviewRequirements = useGoToBulkReviewRequirements();

  return (
    <WSAlert
      my="L"
      title="Bulk review available"
      icon="collection"
      action={{
        text: "Bulk review requirements",
        onClick: () => {
          goToBulkReviewRequirements(
            mapPayeeFiltersToRequirement(props.payeeFilters)
          );
        }
      }}
    >
      Based on the filter you selected, there is a bulk review flow available to
      manage requirements across multiple contractors.
    </WSAlert>
  );
};
